/**
 * A largura da área de trabalho, num lugar só.
 *
 * DUAS CORREÇÕES ATÉ CHEGAR AQUI, E A SEGUNDA DESFEZ METADE DA PRIMEIRA.
 *
 * Era 1100 em onze arquivos. Baixei para 960 porque a lista de indicador punha
 * o nome à esquerda e o valor a 900px dele — o olho perde a linha no caminho.
 * Resolveu o par rótulo-valor e criou um defeito maior: numa tela de 1920 o
 * produto virava uma coluna estreita no meio, com um terço da largura vazio de
 * cada lado. A régua deste produto é terminal de mercado; terminal não deixa
 * meia tela em branco.
 *
 * A largura volta a preencher a tela, e o par rótulo-valor é resolvido onde o
 * problema mora, não estrangulando a página:
 *
 * - `ListaDeIndicadores` ganhou condutor pontilhado entre o nome e o número, o
 *   recurso que relatório financeiro impresso usa há um século exatamente para
 *   isto.
 * - Os blocos de leitura passam a ocupar DUAS COLUNAS a partir de 1200px
 *   (`Colunas`), então a largura extra vira mais conteúdo por dobra, e não
 *   linhas mais longas.
 *
 * O limite existe para a tela ultralarga: acima de ~1700px de conteúdo até uma
 * grade de duas colunas começa a esticar demais a linha de texto.
 */
export const LARGURA_DE_LEITURA = 1680;

export default LARGURA_DE_LEITURA;
